















































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
	...mapGetters(["account", "accountBook"]),
})
export default class voucherTitle extends Vue {
	@Prop({ type: Boolean })
	canFindPre: any;

	@Prop({ type: Boolean })
	canFindNext: any;

	@Prop({ type: Boolean })
	isDialog: any;

	@Prop({ type: Number })
	state: any;

	//键盘快捷键数据
	shortData: any = [
		{
			pingzheng: "保存并新增",
			shortCut: "ALT+S",
		},
		{
			pingzheng: "新增",
			shortCut: "ALT+N",
		},
		{
			pingzheng: "新增科目(选择科目时)",
			shortCut: "F10",
		},
		{
			pingzheng: "新增辅助核算(选择辅助核算时)",
			shortCut: "F1",
		},
		{
			pingzheng: "录入第二条分录",
			shortCut: "Enter",
		},
		{
			pingzheng: "新增科目保存",
			shortCut: "Enter",
		},
		{
			pingzheng: "自动平衡借贷方金额",
			shortCut: "=",
		},
		{
			pingzheng: "保存",
			shortCut: "CTRL+S",
		},
		{
			pingzheng: "凭证模板",
			shortCut: "F4",
		},
		{
			pingzheng: "自动切换借贷金额",
			shortCut: "Space(空格)",
		},
	];

	// 读取上一张
	findprevious() {
		this.$emit("findprevious");
	}

	// 读取下一张
	findnext() {
		this.$emit("findnext");
	}

	//跳转至凭证列表
	toVoucherList() {
		this.$router.push({ path: "/voucherList" });
	}

	// 审核状态显示
	auditText: string = "未启用审核";
	@Watch("state")
	stateChange(val: number) {
		if (val === 0) {
			this.auditText = "未审核";
		} else {
			this.auditText = "已审核";
		}
	}
}
